const grey2 = "#f7f8f8";
const grey3 = "#eff0f0";
const grey5 = "#e0e2e2";
const grey10 = "#d0d3d3";
const grey15 = "#bdc0c0";
const grey20 = "#a9adad";
const grey25 = "#9da1a1";
const grey30 = "#878a8c";
const grey35 = "#676b6e";
const grey40 = "#53575b";
const grey60 = "#3a3d40";
const grey90 = "#0D0F10";
const yellow5 = "#ffd61a";
const yellow10 = "#ffb81c";
const yellow15 = "#faa61a";
const yellow20 = "#f68d2e";
const yellow25 = "#e66a1f";
const yellow30 = "#d45311";
const yellow35 = "#974a07";
const yellow40 = "#674730";
const red5 = "#fda1b2";
const red10 = setAppearanceConstantGlobal("red10", {
  light: "#fc4e6d",
  dark: "#FF7591"
});
const red15 = setAppearanceConstantGlobal("red15", {
  light: "#e10f5a",
  dark: "#ED3A65"
});
const red20 = "#bd0057";
const red25 = "#a6004e";
const red30 = "#8f124a";
const red35 = "#7d003f";
const red40 = "#6e0d33";
const blue5 = "#b0eefc";
const blue10 = "#7de3f4";
const blue15 = "#49cce6";
const blue20 = "#01b6d1";
const blue25 = "#007da5";
const blue30 = "#006184";
const blue35 = "#005175";
const blue40 = "#003057";
const green5 = "#d3e952";
const green10 = "#bed21e";
const green15 = "#93c742";
const green20 = "#6db344";
const green25 = "#50a83e";
const green30 = "#318d43";
const green35 = "#206b3f";
const green40 = "#235c35";
const text120 = "#212225";
const black = "#000000";
const white = "#ffffff";
const colorFacebook = "#3b5998";
const colorInstagram = "#3c5a96";
const colorPinterest = "#cb2027";
const colorYoutube = "#cd201f";
const colorOdnok = "#ed812b";
const colorVk = "#45668e";
const sans = `"Ensign:Sans", Roboto, Arial, sans-serif`;
const serif = `"Ensign:Serif", "Noto Serif", Georgia, serif`;
const monospace = `Courier, "Courier New", monospace`;
const fontWeightLight = 300;
const fontWeightNormal = 400;
const fontWeightSemiBold = 600;
const fontWeightBold = 700;
const fontSizeRoot = `100%`;
const fontSize11 = "0.6875rem";
const fontSize13 = "0.8125rem";
const fontSize14 = "0.875rem";
const fontSize16 = "1rem";
const fontSize18 = "1.125rem";
const fontSize20 = "1.25rem";
const fontSize28 = "1.75rem";
const fontSize32 = "2rem";
const fontSize42 = "2.625rem";
const lineHeightTight = 1.2;
const lineHeight = 1.4;
const lineHeightLoose = 1.6;
const spacing4 = "0.25rem";
const spacing8 = "0.5rem";
const spacing16 = "1rem";
const spacing24 = "1.5rem";
const spacing32 = "2rem";
const spacing48 = "3rem";
const spacing64 = "4rem";
const spacing96 = "6rem";
const spacing128 = "8rem";
const breakWidth480 = "480px";
const breakWidth600 = "600px";
const breakWidth840 = "840px";
const breakWidth960 = "960px";
const breakWidth1280 = "1280px";
const breakWidth1440 = "1440px";
const breakWidth1600 = "1600px";
const aspectRatio1By1 = { width: 1, height: 1, key: "1:1" };
const aspectRatio5By6 = { width: 5, height: 6, key: "5:6" };
const aspectRatio5By8 = { width: 5, height: 8, key: "5:8" };
const aspectRatio6By5 = { width: 6, height: 5, key: "6:5" };
const aspectRatio8By3 = { width: 8, height: 3, key: "8:3" };
const aspectRatio8By5 = { width: 8, height: 5, key: "8:5" };
const aspectRatio16By9 = { width: 16, height: 9, key: "16:9" };
const aspectRatios = [
  aspectRatio1By1,
  aspectRatio5By6,
  aspectRatio5By8,
  aspectRatio6By5,
  aspectRatio8By3,
  aspectRatio8By5,
  aspectRatio16By9
];
const zIndexHigherThanPlatform = 200;
const borderRadius = "0.125rem";
const whiteTransparency10 = "#FFFFFFDE";
const whiteTransparency20 = "#FFFFFF99";
const whiteTransparency30 = "#FFFFFF61";
const whiteTransparency40 = "#FFFFFF3D";
const whiteTransparency50 = "#FFFFFF33";
const whiteTransparency60 = "#FFFFFF29";
const whiteTransparency70 = "#FFFFFF1F";
const whiteTransparency80 = "#FFFFFF14";
import { setAppearanceConstantGlobal } from "./modes";
import {
  setAppearanceConstant,
  getAppearanceConstant,
  setAppearanceConstantLocal
} from "./modes";
const backgroundColorAlt = setAppearanceConstantGlobal(
  "background-color-alt",
  {
    light: grey3,
    dark: whiteTransparency30
  }
);
const backgroundColorHover = setAppearanceConstantGlobal(
  "background-color-hover",
  {
    light: grey3,
    dark: whiteTransparency60
  }
);
const backgroundColorActive = setAppearanceConstantGlobal(
  "background-color-active",
  {
    light: grey5,
    dark: whiteTransparency40
  }
);
const backgroundColorDisabled = setAppearanceConstantGlobal(
  "background-color-disabled",
  {
    light: grey2,
    dark: whiteTransparency70
  }
);
const backgroundColorLevelCurrent = setAppearanceConstantGlobal(
  "background-color-level-current",
  {
    light: white,
    dark: "#121212"
  }
);
const backgroundColorLevel1 = setAppearanceConstantGlobal(
  "background-color-level1",
  {
    light: white,
    dark: "#121212"
  }
);
const backgroundColorLevel2 = setAppearanceConstantGlobal(
  "background-color-level2",
  {
    light: white,
    // 8% white on #121212
    dark: "#252525"
  }
);
const backgroundColorLevel3 = setAppearanceConstantGlobal(
  "background-color-level3",
  {
    light: white,
    // 11% white on #121212
    dark: "#2c2c2c"
  }
);
const backgroundColorLevel4 = setAppearanceConstantGlobal(
  "background-color-level4",
  {
    light: white,
    // 14% white on #121212
    dark: "#333333"
  }
);
const backgroundColorLevel5 = setAppearanceConstantGlobal(
  "background-color-level5",
  {
    light: white,
    // 16% white on #121212
    dark: "#383838"
  }
);
const textColorPrimary = setAppearanceConstantGlobal(
  "text-color-primary",
  {
    light: text120,
    dark: whiteTransparency10
  }
);
const textColorSecondary = setAppearanceConstantGlobal(
  "text-color-secondary",
  {
    light: grey40,
    dark: whiteTransparency20
  }
);
const textColorTertiary = setAppearanceConstantGlobal(
  "text-color-tertiary",
  {
    light: grey30,
    dark: whiteTransparency30
  }
);
const textColorInverted = setAppearanceConstantGlobal(
  "text-color-inverted",
  {
    light: white,
    dark: black
  }
);
const accentColorLink = setAppearanceConstantGlobal(
  "accent-color-link",
  {
    light: "#157493",
    dark: blue15
  }
);
const accentColorLinkActive = setAppearanceConstantGlobal(
  "accent-color-link-active",
  {
    light: "#b00504",
    dark: "#FF7770"
  }
);
const accentColorLinkVisited = setAppearanceConstantGlobal(
  "accent-color-link-visited",
  {
    light: "#9C4F9C",
    dark: "#C092FC"
  }
);
const accentColorPrimary = setAppearanceConstantGlobal(
  "accent-color-primary",
  {
    light: blue30,
    dark: blue15
  }
);
const accentColorInfo = setAppearanceConstantGlobal(
  "accent-color-info",
  {
    light: blue30,
    dark: blue10
  }
);
const accentColorConfirmation = setAppearanceConstantGlobal(
  "accent-color-confirmation",
  {
    light: green30,
    dark: green10
  }
);
const accentColorWarning = setAppearanceConstantGlobal(
  "accent-color-warning",
  {
    light: yellow30,
    dark: yellow10
  }
);
const accentColorDanger = setAppearanceConstantGlobal(
  "accent-color-danger",
  {
    light: "#b00504",
    dark: "#ff7770"
  }
);
const borderColorPrimary = setAppearanceConstantGlobal(
  "border-color-primary",
  {
    light: grey30,
    dark: whiteTransparency20
  }
);
const borderColorSecondary = setAppearanceConstantGlobal(
  "border-color-secondary",
  {
    light: grey15,
    dark: whiteTransparency30
  }
);
const borderColorTertiary = setAppearanceConstantGlobal(
  "border-color-tertiary",
  {
    light: grey5,
    dark: whiteTransparency70
  }
);
const highlightRed = setAppearanceConstantGlobal("highlight-red", {
  light: "#FE4F6633",
  dark: "#BA505E61"
});
const highlightOrange = setAppearanceConstantGlobal("highlight-orange", {
  light: "#FE98293D",
  dark: "#C68A4E61"
});
const highlightYellow = setAppearanceConstantGlobal("highlight-yellow", {
  light: "#FCDB3B61",
  dark: "#D6BF5961"
});
const highlightGreen = setAppearanceConstantGlobal("highlight-green", {
  light: "#A9D5273D",
  dark: "#8CA05261"
});
const highlightBlue = setAppearanceConstantGlobal("highlight-blue", {
  light: "#10D9E133",
  dark: "#60B5B861"
});
const highlightDarkBlue = setAppearanceConstantGlobal(
  "highlight-darkblue",
  {
    light: "#2596FF29",
    dark: "#5587B561"
  }
);
const highlightPurple = setAppearanceConstantGlobal("highlight-purple", {
  light: "#9D53FE29",
  dark: "#7654A561"
});
const highlightPink = setAppearanceConstantGlobal("highlight-pink", {
  light: "#F85BEA33",
  dark: "#B56BB04D"
});
const highlightBrown = setAppearanceConstantGlobal("highlight-brown", {
  light: "#CD7D5A33",
  dark: "#946D5D61"
});
const highlightGrey = setAppearanceConstantGlobal("highlight-grey", {
  light: "#AEB8C13D",
  dark: "#8E969C61"
});
const boxShadowRaised = setAppearanceConstantGlobal(
  "box-shadow-raised",
  {
    light: "0 2px 4px 0 #00000033",
    // 20%
    dark: "0 2px 4px 0 #00000066"
    // 40%
  }
);
const boxShadowDetached = setAppearanceConstantGlobal(
  "box-shadow-detached",
  {
    light: "0 4px 8px 0 #00000033",
    dark: "0 4px 8px 0 #00000066"
  }
);
const boxShadowOverlaid = setAppearanceConstantGlobal(
  "box-shadow-overlaid",
  {
    light: "0 8px 16px 0 #00000033",
    dark: "0 8px 16px 0 #00000066"
  }
);
const boxShadowPoppedOut = setAppearanceConstantGlobal(
  "box-shadow-popped",
  {
    light: "0 16px 32px 0 #00000033",
    dark: "0 16px 32px 0 #00000066"
  }
);
const colorScheme = setAppearanceConstantGlobal("color-scheme", {
  light: "light",
  dark: "dark"
});
export {
  accentColorConfirmation,
  accentColorDanger,
  accentColorInfo,
  accentColorLink,
  accentColorLinkActive,
  accentColorLinkVisited,
  accentColorPrimary,
  accentColorWarning,
  aspectRatio16By9,
  aspectRatio1By1,
  aspectRatio5By6,
  aspectRatio5By8,
  aspectRatio6By5,
  aspectRatio8By3,
  aspectRatio8By5,
  aspectRatios,
  backgroundColorActive,
  backgroundColorAlt,
  backgroundColorDisabled,
  backgroundColorHover,
  backgroundColorLevel1,
  backgroundColorLevel2,
  backgroundColorLevel3,
  backgroundColorLevel4,
  backgroundColorLevel5,
  backgroundColorLevelCurrent,
  black,
  blue10,
  blue15,
  blue20,
  blue25,
  blue30,
  blue35,
  blue40,
  blue5,
  borderColorPrimary,
  borderColorSecondary,
  borderColorTertiary,
  borderRadius,
  boxShadowDetached,
  boxShadowOverlaid,
  boxShadowPoppedOut,
  boxShadowRaised,
  breakWidth1280,
  breakWidth1440,
  breakWidth1600,
  breakWidth480,
  breakWidth600,
  breakWidth840,
  breakWidth960,
  colorFacebook,
  colorInstagram,
  colorOdnok,
  colorPinterest,
  colorScheme,
  colorVk,
  colorYoutube,
  fontSize11,
  fontSize13,
  fontSize14,
  fontSize16,
  fontSize18,
  fontSize20,
  fontSize28,
  fontSize32,
  fontSize42,
  fontSizeRoot,
  fontWeightBold,
  fontWeightLight,
  fontWeightNormal,
  fontWeightSemiBold,
  getAppearanceConstant,
  green10,
  green15,
  green20,
  green25,
  green30,
  green35,
  green40,
  green5,
  grey10,
  grey15,
  grey2,
  grey20,
  grey25,
  grey3,
  grey30,
  grey35,
  grey40,
  grey5,
  grey60,
  grey90,
  highlightBlue,
  highlightBrown,
  highlightDarkBlue,
  highlightGreen,
  highlightGrey,
  highlightOrange,
  highlightPink,
  highlightPurple,
  highlightRed,
  highlightYellow,
  lineHeight,
  lineHeightLoose,
  lineHeightTight,
  monospace,
  red10,
  red15,
  red20,
  red25,
  red30,
  red35,
  red40,
  red5,
  sans,
  serif,
  setAppearanceConstant,
  setAppearanceConstantLocal,
  spacing128,
  spacing16,
  spacing24,
  spacing32,
  spacing4,
  spacing48,
  spacing64,
  spacing8,
  spacing96,
  text120,
  textColorInverted,
  textColorPrimary,
  textColorSecondary,
  textColorTertiary,
  white,
  whiteTransparency10,
  whiteTransparency20,
  whiteTransparency30,
  whiteTransparency40,
  whiteTransparency50,
  whiteTransparency60,
  whiteTransparency70,
  whiteTransparency80,
  yellow10,
  yellow15,
  yellow20,
  yellow25,
  yellow30,
  yellow35,
  yellow40,
  yellow5,
  zIndexHigherThanPlatform
};
